import React, {useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import MaterialTable, {MTableToolbar} from "material-table";
import {useDispatch} from "react-redux";
import {removeFamilyData, setFamilyData} from "../../modules/family";
import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import useMediaQuery from "@material-ui/core/useMediaQuery/useMediaQuery";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {
  answerState,
  familyGridTitle,
  familyState,
  menuCheckSelector,
  selectedMenuItemState, userState
} from '../../state/globalState'
import {getCommCode} from "../../lib/api/code";
import CheckBox from "@material-ui/core/Checkbox";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        borderRadius: 15,
        backgroundColor: "#1b6817",
        padding: '5px 30px',
        height: 35,
        fontSize: "15px",
        color: 'white',
        '&:hover': {
            backgroundColor: '#767676',
            color: '#ffffff'
        }
    },
    formControl: {
        margin: theme.spacing(1),
        width: '100%',
        minWidth: 120,
    },
}));

const ssnCheck = (ssn) => {
    return isKorJumin(ssn);
}

function isKorJumin(ssn) {
    var ssn2f = ssn.substr(6, 1);
    var birth = ssn.substr(0, 4);

    if (ssn2f === '3' || ssn2f === '4') {
        if (Number(birth) >= 2010) {
            return true;
        }
    }

    var rn = ssn;
    if (ssn2f === '5' || ssn2f === '6' || ssn2f === '7' || ssn2f === '8') {
        var type = 'frn';
    } else {
        var type = 'kor';
    }
    return isJumin(rn, type);
}

function isJumin(rn, type) {
    rn = rn.split("-").join('');
    if (rn.length !== 13) return false;
    var checkSum = 0;
    for (var i = 0; i < 12; i++) checkSum += ((rn.substr(i, 1) >> 0) * ((i % 8) + 2));
    var korMatch = (11 - (checkSum % 11)) % 10 == rn.substr(12, 1);
    var frnMatch = (13 - (checkSum % 11)) % 10 == rn.substr(12, 1);
    if (type === 'kor') return korMatch;
    else if (type === 'frn') return frnMatch;
    else return korMatch || frnMatch;
}


const Family = (props) => {
    const [family, setFamily] = useRecoilState(familyState);
    // const userInfo = useRecoilValue(userState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const dispatch = useDispatch();
    const classes = useStyles();
    const [relCodeList, setRelCodeList] = React.useState([]);
    const [relCd, setRelCd] = React.useState({});
    const [answer, setAnswer] = useRecoilState(answerState);
    const [open, setOpen] = React.useState(false);
    const [famyName, setFamyName] = React.useState('');
    const [famySsnNo, setFamySsnNo] = React.useState('');
    const [famyRltCd, setFamyRltCd] = React.useState('');
    const [famyIncomeAmt, setFamyIncomeAmt] = React.useState('');
    const [famyCareYn, setFamyCareYn] = React.useState('');
    const [famyObsYn, setFamyObsYn] = React.useState('');
    const [rowData, setRowData] = React.useState([]);

    const [famyNameError, setFamyNameError] = React.useState("");
    const [famySsnNoError, setFamySsnNoError] = React.useState("");
    const [famyRltCdError, setFamyRltCdError] = React.useState("");
    const [famyIncomeError, setFamyIncomeError] = React.useState("");
    const [famyCareYnError, setFamyCareYnError] = React.useState("");
    const [famyObsYnError, setFamyObsYnError] = React.useState("");
    const [errMsg, setErrMsg] = React.useState('');
    const [familyList, setFamilyList] = React.useState([]);
    let isError = false;
    const gridTitle = useRecoilValue(familyGridTitle)


    const matches = useMediaQuery('(max-width:600px)');

    const getCommCodeList = async (gropCd) => {
        const { data } = await getCommCode(gropCd)
        setRelCodeList(data.payload);
    };

    useEffect(() => {
        getCommCodeList("YA011");
    }, []);

    useEffect(() => {
        const tmpRelCdList = JSON.parse(localStorage.getItem("YA011"));
        setRelCodeList(tmpRelCdList);
    }, []);

    useEffect(() => {
        const tmpRelCd = {};
        relCodeList && relCodeList.map((item) => (
            tmpRelCd[item.commDetlsCd] = item.detlsCdNm
        ));
        setRelCd(tmpRelCd);
    }, [relCodeList]);


    useEffect(() => {
        // let list = [];
        // for (let key in family) {
        //     list.push(family[key]);
        // }
        // setFamilyList(family);
        const newList = [
            ...family
        ];
        // setFamilyList(newList);
        setFamilyList(JSON.parse(JSON.stringify(newList)));
    }, [family]);

    const handleInputFamily = (e) => {

        const namePattern = /^[가-힣a-zA-Z\s]{2,25}$/;
        const ssnPattern = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))(-|)[1-8][0-9]{6}$/g;
        const incomePattern = /^\d/;

        if (e.target.id === 'famyName' && e.target.value.length <= 25) {
            const flag = namePattern.test(e.target.value);
            if (flag) {
                setFamyNameError("");
            } else {
                setFamyNameError("잘못된 이름입니다.");
            }

            setFamyName(e.target.value);
        } else if (e.target.id === 'famySsnNo' && e.target.value.length <= 13) {
            const flag = ssnPattern.test(e.target.value);
            if (flag) {
                // 2020년 10월 이후 출생자 체크
                const firstDigitOfBackNum = e.target.value.slice(6, 7);
                const yearPrefix = (firstDigitOfBackNum === '3' || firstDigitOfBackNum === '4') ? '20' : '19';
                const birthYear = parseInt(yearPrefix + e.target.value.slice(0, 2));
                const birthMonth = parseInt(e.target.value.slice(2, 4));

                const is2020Oct = birthYear === 2020 && birthMonth >= 10;
                const isAfter2020Oct = birthYear > 2020;
                if (is2020Oct || isAfter2020Oct) {
                    setFamySsnNoError("");
                } else {
                    if (ssnCheck(e.target.value)) {
                        setFamySsnNoError("");
                    } else {
                        setFamySsnNoError("주민등록번호를 다시 확인해주세요.");
                    }
                }
            } else {
                setFamySsnNoError("주민등록번호를 다시 확인해주세요.");
            }

            setFamySsnNo(e.target.value);

        } else if (e.target.id === 'famyIncomeAmt') {
            const regexp = /\B(?=(\d{3})+(?!\d))/g;
            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
            const toNum = Number(onlyNums);

            if (toNum.toString().length < 13) {
                const number = toNum.toString().replace(regexp, ',');
                setFamyIncomeError("");
                setFamyIncomeAmt(number);
            }
        }
    };

    const handleRltCd = (e) => {
        setFamyRltCdError("");
        setFamyRltCd(e.target.value);
    };

    const handleCareYn = (e) => {
        setFamyCareYnError("");
        setFamyCareYn(e.target.value);
    };

    const handleObsYn = (e) => {
        setFamyObsYnError("");
        setFamyObsYn(e.target.value);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setFamyName('');
        setFamySsnNo('');
        setFamyRltCd('');
        setFamyIncomeAmt('');
        setFamyCareYn('');
        setFamyObsYn('');

        setFamyNameError("");
        setFamySsnNoError("");
        setFamyRltCdError("");
        setFamyIncomeError("");
        setFamyCareYnError("");
        setFamyObsYnError("");
        setErrMsg('');

        setOpen(false);
    };

    // 부양가족 정보 추가
    const handleAddConfirm = () => {

        const newData = {
            kognrFmifSeq: family.length + 1,
            famyNm: famyName,
            famySsnNo: famySsnNo,
            famyRltGcd: famyRltCd,
            famyRltNm: relCd[famyRltCd],
            famyIncomeAmt: famyIncomeAmt,
            famyCareYn: famyCareYn,
            famyObsYn: famyObsYn,
            flag: "add"
        };


        if (!validationCheck(newData)) {
            return false;
        }

        const newFamily = [
            ...family,
            newData
        ];
        setFamily(newFamily);

        setSelectedMenuItem('SURVEY_15');
        setMenuCheck(true);

        setSelectedMenuItem('SURVEY_16');
        setMenuCheck(true);

        handleClose();
    };

    const removeSelected = () => {
        const seqList = rowData.map((data) => data.kognrFmifSeq);
        const newFamily = family.filter((item) => {
            return !seqList.includes(item.kognrFmifSeq);
        });

        family.forEach((f, i)=> {
                const fam = {
                    ...f,
                    kognrFmifSeq: i + 1,
                }
            }
        )
        setFamily(newFamily);

        if (newFamily.length < 1) {
            setSelectedMenuItem('SURVEY_16');
            setMenuCheck(false);
        }
        // rowData.forEach(function (item) {
        //     dispatch(removeFamilyData({
        //         fmifSeq: item.kognrFmifSeq
        //     }));
        // });
        //
        // if (rowData.length < 1) {
        //     dispatch(changeState({
        //         key: 'SURVEY_15',
        //         isChecked: false
        //     }));
        //     dispatch(changeState({
        //         key: 'SURVEY_16',
        //         isChecked: false
        //     }));
        // }
    };

    const validationCheck = (family) => {
        // famyNm
        if (family.famyNm === undefined || family.famyNm === '') {
            setFamyNameError("필수 입력 항목입니다.");
            isError = true;
        }

        // famySsnNo
        if (family.famySsnNo === undefined || family.famySsnNo === '') {
            setFamySsnNoError("필수 입력 항목입니다.");
            isError = true;
        }

        // FAMY_RLT_CD
        if (family.famyRltGcd === undefined || family.famyRltGcd === '') {
            setFamyRltCdError("필수 입력 항목입니다.");
            isError = true;
        }

        // famyIncomeAmt
        if (family.famyIncomeAmt === undefined || family.famyIncomeAmt === '') {
            setFamyIncomeError("필수 입력 항목입니다.");
            isError = true;
        }

        // famyCareYn
        if (family.famyCareYn === undefined || family.famyCareYn === '') {
            setFamyCareYnError("필수 입력 항목입니다.");
            isError = true;
        }

        // famyObsYn
        if (family.famyObsYn === undefined || family.famyObsYn === '') {
            setFamyObsYnError("필수 입력 항목입니다.");
            isError = true;
        }

        if (famyNameError || famySsnNoError || famyRltCdError || famyIncomeError || famyCareYnError || famyObsYnError) {
            isError = true;
        }

        return !isError;
    };

    const handleOnChangeCheckBox = (e) => {
        setAnswer({
            ...answer,
            onePersonHouseholdYn: e.target.checked ? "1" : "0"
        })
    };
  const hasYA011003 = family?.some(f => f.famyRltGcd === 'YA011003');

    return (
        <Grid container>
            <Container hidden={props.hidden}>
                <Paper className={classes.paper}>
                    <div className={classes.tableWrapper}>
                        <MaterialTable
                            options={{
                                search: false,
                                selection: true,
                                paging: false
                            }}
                            localization={{
                                toolbar: {
                                    nRowsSelected: '{0} row(s) selected'
                                },
                                header: {
                                    actions: 'Actions'
                                },
                                body: {
                                    emptyDataSourceMessage: '부양가족 정보가 없습니다.'
                                }
                            }}
                            onSelectionChange={(rows) => {
                                setRowData(rows);
                            }}
                            // onSelectionChange={(rows) => setRowData(rows)}
                            components={{
                                Toolbar: props => (
                                    <div>
                                        <MTableToolbar {...props} />
                                        <div style={{padding: '0px 10px'}}>
                                            <Button
                                                variant="contained"
                                                className={classes.button}
                                                id='add-row'
                                                name='add-row'
                                                onClick={handleClickOpen}
                                            >
                                                추가
                                            </Button>
                                            <Button
                                                variant="contained"
                                                className={classes.button}
                                                id='delete-row'
                                                name='delete-row'
                                                onClick={removeSelected}
                                            >
                                                삭제
                                            </Button>
                                            <FormControlLabel control={
                                                <CheckBox
                                                    checked={answer.onePersonHouseholdYn === "1"}
                                                    onChange={(e)=>  handleOnChangeCheckBox(e)}
                                                />}
                                                              label="신청할 부양가족 없음"
                                                              style={{paddingLeft: '10px'}}
                                            />
                                        </div>
                                    </div>
                                ),
                            }}
                            columns={[
                                {
                                    title: "kognrFmifSeq",
                                    field: "kognrFmifSeq",
                                    hidden: true,
                                    headerStyle: {alignContent: 'center'}
                                },
                                {title: "성명", field: "famyNm", headerStyle: {width: '20%'}},
                                {title: "주민등록번호", field: "famySsnNo", headerStyle: {width: '20%', whiteSpace: 'nowrap'}, render: rowData => {
                                    const ssn = rowData.famySsnNo || '';
                                    const digitsOnly = ssn.replace(/\D/g, '');
                                    if (digitsOnly.length < 7) return digitsOnly;

                                    const front = digitsOnly.slice(0, 6);
                                    const backFirst = digitsOnly[6];
                                    const masked = `${front}-${backFirst}${'*'.repeat(6)}`;

                                    const display = rowData.flag === "add"
                                      ? `${front}-${digitsOnly.slice(6)}`
                                      : masked;

                                    return (
                                      <span style={{ fontSize: '0.85rem' }}>{display}</span> // 폰트 크기 줄이기
                                    );
                                  }},
                                {title: "가족\n관계", field: "famyRltGcd", lookup: relCd, headerStyle: {width: '15%', whiteSpace: 'pre-line'}, cellStyle: {fontSize: '100'}},
                                {title: "소득금액", field: "famyIncomeAmt", type: "numeric", headerStyle: {width: '15%'}},
                                {
                                    title: "부양\n여부",
                                    field: "famyCareYn",
                                    lookup: {'1': '예', '0': '아니오'},
                                    headerStyle: {width: '15%', whiteSpace: 'pre-line'}
                                },
                                {
                                    title: "장애\n여부",
                                    field: "famyObsYn",
                                    lookup: {'1': '예', '0': '아니오'},
                                    headerStyle: {width: '15%', whiteSpace: 'pre-line'}
                                }
                            ]}
                            data={familyList}
                            title={<div style={{ whiteSpace: 'pre-line', fontWeight: '400', fontSize: '20px' }}>{gridTitle}</div>}
                        />
                    </div>

                    <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title"
                            fullWidth={true}
                            maxWidth={'md'}>
                        <DialogTitle id="form-dialog-title">부양가족 정보 추가</DialogTitle>
                        <DialogContent>
                            <div>
                                <DialogContentText>
                                    부양가족으로 신청하실 가족정보를 입력하세요.
                                </DialogContentText>
                            </div>
                            <div style={matches ? {height: 550} : {height: 330}}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.formControl}>
                                            <TextField
                                                error={famyNameError}
                                                required
                                                id="famyName"
                                                name="famyName"
                                                label="성명"
                                                fullWidth
                                                helperText={famyNameError}
                                                autoFocus={true}
                                                value={famyName}
                                                onChange={handleInputFamily}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.formControl}>
                                            <TextField
                                                error={famySsnNoError}
                                                required
                                                inputStyle={{textAlign: 'center'}}
                                                id="famySsnNo"
                                                name="famySsnNo"
                                                label="주민등록번호"
                                                helperText={famySsnNoError}
                                                fullWidth
                                                value={famySsnNo}
                                                onChange={handleInputFamily}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.formControl} error={famyRltCdError}>
                                            <InputLabel required id="famyRltCd-label">가족관계</InputLabel>
                                            <Select
                                                required
                                                labelId="famyRltCd-label"
                                                id="famyRltCd"
                                                value={famyRltCd}
                                                onChange={handleRltCd}
                                            >
                                              {
                                                relCodeList &&
                                                relCodeList
                                                .filter(item =>
                                                  item.commDetlsCd !== 'YA011000' &&
                                                  !(hasYA011003 && item.commDetlsCd === 'YA011003')
                                                )
                                                .map(item => (
                                                  <MenuItem
                                                    key={item.commDetlsCd}
                                                    value={item.commDetlsCd}
                                                  >
                                                    {item.detlsCdNm}
                                                  </MenuItem>
                                                ))
                                              }
                                            </Select>
                                            <FormHelperText>{famyRltCdError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.formControl}>
                                            <TextField
                                                error={famyIncomeError}
                                                required
                                                inputStyle={{textAlign: 'right'}}
                                                id="famyIncomeAmt"
                                                name="famyIncomeAmt"
                                                label="소득금액"
                                                helperText={famyIncomeError}
                                                fullWidth
                                                value={famyIncomeAmt}
                                                onChange={handleInputFamily}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.formControl} error={famyCareYnError}>
                                            <FormLabel required component="legend">부양여부</FormLabel>
                                            <RadioGroup aria-label="famy-care-rg" name="famy-care-rg" value={famyCareYn}
                                                        onChange={handleCareYn} row>
                                                <FormControlLabel
                                                    value="1"
                                                    control={<Radio color="primary"/>}
                                                    label="예"
                                                    labelPlacement="end"
                                                />
                                                <FormControlLabel
                                                    value="0"
                                                    control={<Radio color="primary"/>}
                                                    label="아니오"
                                                    labelPlacement="end"
                                                />
                                            </RadioGroup>
                                            <FormHelperText>{famyCareYnError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl className={classes.formControl} error={famyObsYnError}>
                                            <FormLabel required component="legend">장애여부 (장애인등록증 및 복지카드 있는 경우에
                                                한함)</FormLabel>
                                            <RadioGroup aria-label="famy-obs-rg" name="famy-care-rg" value={famyObsYn}
                                                        onChange={handleObsYn} row>
                                                <FormControlLabel
                                                    value="1"
                                                    control={<Radio color="primary"/>}
                                                    label="예"
                                                    labelPlacement="end"
                                                />
                                                <FormControlLabel
                                                    value="0"
                                                    control={<Radio color="primary"/>}
                                                    label="아니오"
                                                    labelPlacement="end"
                                                />
                                            </RadioGroup>
                                            <FormHelperText>{famyCareYnError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="secondary">
                                취소
                            </Button>
                            <Button onClick={handleAddConfirm} color="primary">
                                확인
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Paper>
            </Container>
        </Grid>
    )
};

export default Family;
